import { render, staticRenderFns } from "./dimensional-box.vue?vue&type=template&id=20260900&scoped=true"
import script from "./dimensional-box.vue?vue&type=script&lang=js"
export * from "./dimensional-box.vue?vue&type=script&lang=js"
import style0 from "./dimensional-box.vue?vue&type=style&index=0&id=20260900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20260900",
  null
  
)

export default component.exports